import request from '@/utils/request'

export function registerProfilesToEim(data) {
  return request({
    url: `/profiles/register_eim`,
    method: 'post',
    data
  })
}

export function findDownloadableProfileOptions(agentId, params) {
  return request({
    url: `/agents/${agentId}/profiles/downloadable_options`,
    method: 'get',
    params
  })
}

export function updateProfileEimData(id) {
  return request({
    url: `/profiles/${id}/eim_data`,
    method: 'post'
  })
}
